import { render, staticRenderFns } from "./NewBattery.vue?vue&type=template&id=a956ff3c"
import script from "./NewBattery.vue?vue&type=script&lang=js"
export * from "./NewBattery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports